import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "value", "selected", "className", "onSelect", "description"];
import { CommandItem } from "../../_shadcn-native-components/command";
import { sanitizeText } from "../utils/sanitize-text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DropdownTextItem = function DropdownTextItem(_ref) {
  var text = _ref.text,
    value = _ref.value,
    selected = _ref.selected,
    className = _ref.className,
    _onSelect = _ref.onSelect,
    description = _ref.description,
    itemProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(CommandItem, _objectSpread(_objectSpread({
    className: className,
    selected: selected,
    value: value,
    onSelect: function onSelect() {
      return _onSelect(value);
    }
  }, itemProps), {}, {
    children: description ? /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-w-full",
      children: [/*#__PURE__*/_jsx("h5", {
        className: "tw-font-subtitle5 tw-truncate tw-w-full",
        children: sanitizeText(text)
      }), /*#__PURE__*/_jsx("p", {
        className: "tw-font-body5 tw-text-neutral-light-700 tw-truncate tw-w-full",
        children: sanitizeText(description)
      })]
    }) : /*#__PURE__*/_jsx("p", {
      className: "tw-truncate",
      children: sanitizeText(text)
    })
  }), value);
};